import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import { mutate } from 'swr';
import Loading from 'components/commercetools-ui/atoms/loading';
import { useFormat } from 'helpers/hooks/useFormat';
import { decrypt } from 'helpers/utils/cryptoJs';
import { sdk } from 'sdk';
import { useCart } from 'frontastic';
import BackToCheckout from './back-to-checkout';
import { useCookies } from 'react-cookie';

// This class is used to finalize redirect flows for some payment methods
export const RedirectContainer = () => {
  const searchParams = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState('');
  const { formatMessage: formatCheckoutMessage } = useFormat({ name: 'checkout' });
  const { data } = useCart();
  useEffect(() => {
    const handleRedirect = async () => {
      if (searchParams && !isLoading && data) {
        const sessionId = searchParams.get('sessionId');
        const redirectResult = searchParams.get('redirectResult');
        const ctSession = searchParams.get('ctSession') as string;
        let mode = '';
        let orderId = '';
        let cartTotal = 0;
        const URIEncodedValue = decodeURIComponent(ctSession);
        const decryptedSession = await decrypt(URIEncodedValue.replace(/ /g, '+'));

        if (decryptedSession) {
          mode = JSON.parse(decryptedSession).mode;
          orderId = JSON.parse(decryptedSession).orderId;
          cartTotal = JSON.parse(decryptedSession).cartTotal;
        }

        if (data?.sum?.centAmount !== cartTotal) {
          setPaymentStatus('refused');
          return;
        }

        if (mode && sessionId) {
          setIsLoading(true);
          setTimeout(() => {
            const createCheckout = async () => {
              const checkout = await AdyenCheckout({
                locale: 'en_GB',
                environment: process.env.NEXT_PUBLIC_ADYEN_ENV,
                clientKey: process.env.NEXT_PUBLIC_ADYEN_CLIENT_KEY,
                session: { id: sessionId },
                onPaymentCompleted: async (response: any, _component: any) => {
                  if (['Authorised'].includes(response.resultCode)) {
                    const payload = {
                      session: ctSession,
                    };

                    await sdk.callAction({ actionName: 'cart/checkout', payload });
                    //const res = await sdk.callAction({ actionName: 'cart/resetCart' });
                    //await mutate('/action/cart/getCart', res);
                    setTimeout(() => {
                      sessionStorage.setItem('pushToDataLayer', 'true');
                      window.location.assign(`/thank-you/?orderId=${orderId}`);
                    }, 10);

                    return;
                  } else if (response.resultCode === 'Refused') {
                    setPaymentStatus('refused');
                  } else if (response.resultCode === 'Pending') {
                    setPaymentStatus('pending');
                  } else if (response.resultCode === 'Cancelled') {
                    setPaymentStatus('cancelled');
                  }
                },
                onError: (error: any, _component: any) => {
                  console.error(error);
                  // toast.error(
                  //   `${formatCheckoutMessage({
                  //     id: 'payment.failed',
                  //     defaultMessage: 'We could not process your payment, please try again later.',
                  //   })}`,
                  // );
                },
              });
              checkout.submitDetails({ details: { redirectResult } }); // we finalize the redirect flow with the reeived payload
            };

            createCheckout();
          }, 100);
        }
      }
    };
    handleRedirect();
  }, [searchParams, data]);

  return (
    <div id="redirect-page" className="relative m-[40px] block h-[200px]">
      {['refused', 'cancelled', 'pending'].includes(paymentStatus) ? (
        <div className="m-18">
          <BackToCheckout paymentStatus={paymentStatus}></BackToCheckout>
        </div>
      ) : (
        <div className="w-full text-center">
          <div className="m-auto w-[420px] text-center">
            <Loading
              text={formatCheckoutMessage({
                id: `payment.processing`,
                defaultMessage:
                  'Your payment is currently being processed. Please keep this window open until completion. Thank you for your patience!',
              })}
            ></Loading>
          </div>
        </div>
      )}
    </div>
  );
};
